import {IPlayer} from "modules/types";
import {PlayerImageType} from "modules/enums";
import {
	IMAGE_CACHE,
	IMAGES_URL,
	MLB_PLAYER_AVATAR_IMAGES,
	MLB_PLAYER_FULL_IMAGES,
	MLB_PLAYER_SHOT_IMAGES,
	REACT_APP_SKIP_BACKEND_IMAGES,
} from "modules/constants";

export abstract class ImageHandler {
	public static getPlayerAvatar = (player: IPlayer, forceLink = false) => {
		return this.getMLBOrOwnImage(
			PlayerImageType.headshot,
			"player_headshot_default.png",
			MLB_PLAYER_AVATAR_IMAGES,
			player,
			forceLink
		);
	};

	public static getPlayerActionShotImage = (player: IPlayer, forceLink = false) => {
		return this.getMLBOrOwnImage(
			PlayerImageType.actionShotImage,
			"player_action_short_default.png",
			MLB_PLAYER_SHOT_IMAGES,
			player,
			forceLink
		);
	};

	public static getPlayerActionFullImage = (
		player: IPlayer,
		forceLink = false
	): Promise<string> | string => {
		return this.getMLBOrOwnImage(
			PlayerImageType.actionFullImage,
			"player_action_full_default.png",
			MLB_PLAYER_FULL_IMAGES,
			player,
			forceLink
		);
	};

	private static generatePlayerImageURL(link: string, player: IPlayer) {
		return link.replace("--player_feed_id--", `${player?.feedId}`);
	}

	private static getMLBOrOwnImage(
		key: PlayerImageType,
		defaultImage: string,
		mlbLink: string,
		player: IPlayer,
		forcePlayerLink = false
	): Promise<string> | string {
		const defaultLink = `${IMAGES_URL}image/${defaultImage}`;

		if (player[key] && !REACT_APP_SKIP_BACKEND_IMAGES) {
			const link = `${IMAGES_URL}image/${String(player[key])}?_=${IMAGE_CACHE}`;
			return this.getImageOrFallback(link, defaultLink);
		}

		const mlbLinkToImage = `${this.generatePlayerImageURL(mlbLink, player)}?_=${IMAGE_CACHE}`;
		if (forcePlayerLink) {
			return mlbLinkToImage;
		}
		return this.getImageOrFallback(mlbLinkToImage, defaultLink);
	}

	private static getImageOrFallback(path: string, fallback: string): Promise<string> {
		return new Promise((resolve) => {
			const img = new Image();
			img.src = path;
			img.onload = () => resolve(path);
			img.onerror = () => resolve(fallback);
		});
	}
}
